import { Flex, IconButton, Spacer, Text, useDisclosure, Wrap, WrapItem } from '@chakra-ui/react';
import { AddIcon, CloseIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import DepartmentSelectModal from './DepartmentSelectModal';
import DepartmentRemoveModal from './DepartmentRemoveModal';
import useStore from '../../store';

const HEIGHT = '32px';

function DepartmentUserAssign({
	permission = null,
	departments = [],
	assignees = [],
	onSelectCallback = (department) => null,
	onRemoveCallback = (department) => null,
}) {
	const { t } = useTranslation();
	const modalSelect = useDisclosure();
	const [canAssign, setCanAssign] = useState(false);
	const [removeDepartment, setRemoveDepartment] = useState(null);
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const { currentUser: user } = useStore((state) => state?.currentUser);

	useEffect(() => setCanAssign(user?.role === 'admin'), [user]);

	return (
		<>
			<Flex minH={HEIGHT}>
				<Flex justifyContent="flex-start" alignItems="flex-start" minWidth="144px" width="144px" mr={2}>
					<Flex minH={HEIGHT} height={HEIGHT} justifyContent="flex-start" alignItems="center">
						<Text fontWeight="bold">{t('Department')}</Text>
					</Flex>
				</Flex>
				<Wrap spacing={2}>
					{departments?.map((e, i) => (
						<WrapItem key={i} height={HEIGHT} alignItems="center" borderWidth={1.5} borderColor="blue.500" pl={2} pr={1}>
							<Text fontSize="sm" fontWeight="600" noOfLines={1}>
								{lang === 'kh' ? e?.labelKh : e?.label}
							</Text>
							<Spacer width={1} />
							<IconButton
								_focus={{ boxShadow: 'none' }}
								hidden={!canAssign}
								icon={<CloseIcon color="blue.500" fontSize="13px" _hover={{ color: 'blue.700' }} />}
								variant="unstyled"
								size="sm"
								onMouseDown={() => setRemoveDepartment(e)}
							/>
						</WrapItem>
					))}
					<WrapItem height={HEIGHT}>
						<IconButton
							_focus={{ boxShadow: 'none' }}
							isDisabled={!canAssign}
							icon={<AddIcon fontSize="13px" />}
							colorScheme="blue"
							height={HEIGHT}
							onMouseDown={modalSelect?.onOpen}
						/>
					</WrapItem>
				</Wrap>
			</Flex>
			<DepartmentSelectModal permission={permission} isOpen={modalSelect?.isOpen} onClose={modalSelect?.onClose} onCallback={onSelectCallback} />
			<DepartmentRemoveModal
				department={removeDepartment}
				assignees={assignees?.filter((e) => e?.department === removeDepartment?.value)}
				isOpen={removeDepartment ? true : false}
				onClose={() => setRemoveDepartment(null)}
				onCallback={onRemoveCallback}
			/>
		</>
	);
}

export default DepartmentUserAssign;
